import { Box, Grid } from '@mui/material';
import ReadinessGaugeGrid from './ReadinessGaugeGrid';
import { ReadinessGaugeInstance } from '@esg/esg-global-types';
import { Heading } from '../shared/typography/PrimaryTypography';
import readiness_gauge_img from '../../assets/home_dashboard/readiness_gauge.webp';

interface ReadinessGaugeHubProps {
  readiness_gauge_instances: Array<ReadinessGaugeInstance>;
  handleUpdateReadinessGaugeInstances: (
    readiness_gauge_instances: Array<ReadinessGaugeInstance>
  ) => void;
}

/**
 * Wrapper component for laying out Readiness Gauge listing elements.
 * @param {Array<ReadinessGaugeInstance>} readiness_gauge_rows Readiness Gauge Instance objects from database from parent.
 * @param {void} handleUpdateReadinessGaugeRows Update Readiness Gauge Instance objects in parent.
 * @returns {JSX.Element}
 */
const ReadinessGaugeHub = ({
  readiness_gauge_instances,
  handleUpdateReadinessGaugeInstances
}: ReadinessGaugeHubProps) => {
  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={4}>
        <Grid size={12}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 4, gap: 4 }}>
            <img src={readiness_gauge_img} width="70px" />
            <Heading weight="Medium">List of ESG Readiness Gauges</Heading>
          </Box>
          <Box sx={{ minHeight: '60vh', width: '100%' }}>
            <ReadinessGaugeGrid
              readiness_gauge_rows={readiness_gauge_instances}
              handleUpdateReadinessGaugeRows={handleUpdateReadinessGaugeInstances}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ReadinessGaugeHub;
